import {useApi} from "@contexts/hooks/api/useApi.ts";
import {useEffect, useState} from "react";

/**
 * Hook que retorna a lista atual de promises pendentes e re-renderiza
 * o componente quando essa lista muda.
 */
export const useApiPromises = () => {
    const {getPromises, subscribeToPromises} = useApi();
    const [promises, setPromises] = useState(() => getPromises());
    useEffect(() => {
        // A função de subscribe retorna uma função de cleanup (unsubscribe)
        // noinspection UnnecessaryLocalVariableJS << ts pedindo pra alinhar, mas não deve ser alinhado, o unsubscribe é chamado ao fechar o componente
        const unsubscribe = subscribeToPromises(() => {
            // Quando notificado, atualiza o estado local com a nova lista de promises
            setPromises(getPromises());
        });

        // Limpa a inscrição quando o componente é desmontado
        return unsubscribe;
    }, [subscribeToPromises, getPromises]);

    return promises;
};